import React, { useEffect, useState } from "react";
import { ChartTimeFilters, CoinGeckoCoinMarketChartParams } from "../../types/types";
import { IonLabel,IonSegment, IonSegmentButton,IonText,IonToolbar } from "@ionic/react";
import { useAppSelector } from "../../services/redux/hook";
import { useGetUserInfoQuery } from "../../services/api/ebioro/ebioro";
import { useGetCoinMarketChartQuery } from "../../services/api/coin-gecko/coingecko";
import './CoinChart.css'
import moment from "moment";

import { LineChart, Line, XAxis, YAxis,Tooltip, ResponsiveContainer } from 'recharts';


const CoinChart: React.FC = () => {

  const selectedAsset = useAppSelector((state) => state.selectedAsset);
  const { data: userInfo } = useGetUserInfoQuery({});
  

  const [segmentValue, setSegmentValue] = useState(ChartTimeFilters.P1D);

  const params: CoinGeckoCoinMarketChartParams = {

    id: selectedAsset.coingecko_id,
    vs_currency: userInfo?.currency_code.toLocaleLowerCase() || 'usd',
    days: segmentValue
  }

  const { data } = useGetCoinMarketChartQuery(params, { skip: (!userInfo) })

  const [priceLabel, setPriceLabel] = useState('0');
  const [dateLabel, setDateLabel] = useState('0');
  const [tooltipActive,setToolTipActive] = useState(false);

  let prices: any = [[0, 0]]
  
  if (data && data.prices) {
    prices = data.prices
   
  }

  const segmentChanged = (value: any) => {

    setSegmentValue(value)
  }



  useEffect(() => {
    
    setPriceLabel(parseFloat(prices[prices.length - 1][1]).toFixed(4))
    setDateLabel(moment(new Date(prices[prices.length - 1][0])).format("dd MMM yyyy:HH:mm"))

  },[prices])


  return (

    <div>
   
      <div>
        <IonText>
          <h1>
          <b>
            {priceLabel} {userInfo?.currency_code}
            </b>
          </h1>
      
        </IonText>

      </div>
      <div>
      <IonText>
          <h5>{dateLabel}</h5>
          </IonText>
      </div>

      <div>

        <ResponsiveContainer   width="100%" height={200} aspect={1.5}  >
          <LineChart data={prices} width={500}
            height={300}
            onMouseMove={(state) =>{
              
              if(state.isTooltipActive){
                if(state.activePayload !== undefined ){
                  setPriceLabel(parseFloat(state.activePayload[0].payload[1]).toFixed(4));
                  setDateLabel(moment(new Date(state.activePayload[0].payload[0])).format("D MMM YYYY, h:mm"));
                }
              }
              
              else{
                setPriceLabel(parseFloat(prices[prices.length - 1][1]).toFixed(4));
                setDateLabel(moment(new Date(prices[prices.length - 1][0])).format("D MMM YYYY, h:mm"));
              }
            }}
           
           
            >
            <Tooltip contentStyle={{display:"none"}} active={tooltipActive} />
            <YAxis type="number" domain={[prices[0][1], prices[prices.length - 1][1]]} hide={true}  />
            <XAxis dataKey={Object.keys(prices[0])[0]} hide={true} />
            <Line type="monotone" dataKey={Object.keys(prices[0])[1]} stroke={'var(--ion-color-secondary)'} dot={false} />
            
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="coinChartToolBar">
        <IonSegment value={segmentValue} onIonChange={(e:any) => segmentChanged(e.detail.value)}>
          <IonSegmentButton value={ChartTimeFilters.P1D} >
            <IonLabel> 1d</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={ChartTimeFilters.P7D}>
            <IonLabel> 1w</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={ChartTimeFilters.P1M}>
            <IonLabel> 1m</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={ChartTimeFilters.P3M}>
            <IonLabel> 3m</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={ChartTimeFilters.P6M}>
            <IonLabel> 6m</IonLabel>
          </IonSegmentButton>
          {/* <IonSegmentButton value={ChartTimeFilters.P1Y}>
            <IonLabel> 1y</IonLabel>
          </IonSegmentButton> */}
        </IonSegment>
        </div>
    </div>


  )
}

export default CoinChart;












